<!--
参数：
options:下拉选项 eg:[{
          value: '选项1',
          label: '黄金糕',
          template:''//用于选中后，输入框中显示的文本
        }, {
          value: '选项2',
          label: '双皮奶'
        }]
multiple:设置模式是否多选，ture or false 默认单选
value:设置默认值，多选模式下，为一个数组，eg:['选项1','选项2']（取options中的value值），单选模式下，为字符串，eg:'选项1'，与options中某个value字段对应
-->
<template>
  <el-select ref="selecter" :class="classes" v-model="selecteds" :multiple="Boolean(multiple)" :allow-create="Boolean(allowCreate)" :filterable="Boolean(filterable)"
  :clearable="Boolean(clearable)" default-first-option :placeholder="placeholder" @change="handleChange" :disabled="Boolean(disabled)" :size="size" :loading="Boolean(loading)" :loading-text="loadingText"
  @clear="handleClear" @visible-change="handleVisible" @remove-tag="handlerRemoveTag" @blur="handleBlur" @focus="handleFocus" :no-data-text="noDataText">
    <el-option
      v-for="item in options"
      :key="item[props.value] || item"
      :disabled="item.disabled"
      :label="item[props.label] || item.template || item"
      :value="item[props.value] || item">
      <span style="float: left">{{item[props.label] || item}}</span>
    </el-option>
    <slot/>
  </el-select>
</template>

<script>
// 组件class前缀
import { Select, Option } from 'element-ui'
const prefixCls = 'wt-selector'

export default {
  name: 'wt-selector',
  components: {
    'el-select': Select,
    'el-option': Option
  },
  props: {
    options: {
      type: Array,
      required: true
    },
    value: {
      type: [Array, String, Number]
    },
    multiple: {
      type: [Boolean, String],
      default: false
    },
    // 是否允许创建，需配合 filterable 使用
    allowCreate: {
      type: [Boolean, String],
      default: false
    },
    // 是否可搜索
    filterable: {
      type: [Boolean, String],
      default: false
    },
    // 单选时是否可清空选项
    clearable: {
      type: [Boolean, String],
      default: false
    },
    placeholder: {
      type: [String],
      default: '请选择'
    },
    props: {
      type: Object,
      default: () => {
        return {
          label: 'label',
          value: 'value'
        }
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    size: {
      type: String
    },
    loadingText: {
      type: String,
      default: '加载中'
    },
    noDataText: {
      type: String,
      default: '无数据'
    },
    loading: {
      type: Boolean,
      default: false
    },
    // 需返回的字段名
    valueFileds: {
      type: String,
      default: null
    },
    showPlacehodlerAlways: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      selecteds: this.value
    }
  },
  watch: {
    value (val) {
      this.selecteds = val
      if (this.showPlacehodlerAlways) {
        let input = this.$refs.selecter.$el.lastChild.firstElementChild
        input.value = this.placeholder
      }
    },
    selecteds (val) {
      this.$emit('input', val)
    }
  },
  methods: {
    handleChange (val) {
      this.$emit('change', val, this.valueFileds)
    },
    handleClear () {
      this.$emit('clear')
    },
    handleVisible (val) {
      this.$emit('visible-change', val)
    },
    handlerRemoveTag (val) {
      this.$emit('removeTag', val)
    },
    handleFocus (e) {
      this.$emit('focus', e)
    },
    handleBlur (e) {
      this.$emit('blur', e)
    }
  },
  computed: {
    classes () {
      return `${prefixCls}`
    }
  }
}
</script>

<style lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
